import type { ProductPrice, RootStoreState } from "@store/types";

import type { OrderItem, Product } from "@jti/magento";

export const getProductPrice = (
  product: OrderItem | Product,
  currency: RootStoreState["cart"]["currency"],
  showPricesWithTaxExcluded = false
): ProductPrice => {
  const { price, price_range } = product;

  if (!("prices" in product) || !product?.prices?.row_total_including_tax) {
    return price;
  }

  const grossPrice = product.prices.row_total_including_tax ?? { value: 0 };
  const netPrice = product.prices.row_total ?? { value: 0 };

  const priceToUse = showPricesWithTaxExcluded ? netPrice : grossPrice;

  const regularPrice = price_range?.minimum_price?.regular_price?.value ?? 0;

  return {
    ...priceToUse,
    currency: currency.code,
    regularPrice,
  };
};
